import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { ID_ASSIST_KEY } from '~/common/constants';
import history from '~/config/history';
import { PATHS } from '~/routes/paths';
import api from '~/services/api';

export default function useQuery() {
  const [params, setParams] = useState({});
  const location = useLocation();

  useEffect(() => {
    try {
      const queriesParams = new URLSearchParams(location.search);
      const result = {};

      api.defaults.headers.token = 'CE9FED21DC762F018B31F0411A3010F0';

      queriesParams.forEach((value, key) => {
        if (key === 'token') {
          api.defaults.headers.token = value;
        } else {
          result[key] = value;
          if (key === 'idAssistServico') {
            window.localStorage.setItem(ID_ASSIST_KEY, value);
          }
        }
      });
      if (!result.idAssistServico) {
        if (window.localStorage.getItem(ID_ASSIST_KEY)) {
          result.idAssistServico = window.localStorage.getItem(ID_ASSIST_KEY);
        } else {
          throw new Error('idAssistServico not provided');
        }
      }

      setParams(result);
    } catch (error) {
      console.error(error);
      history.replace(PATHS.notfound);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { params };
}
